/** A field's suggestion indicator when it has one, otherwise the field element itself. */
export const findFieldIndicator = (fieldId: string, root: ParentNode = document): HTMLElement | null =>
  root.querySelector<HTMLElement>(`[data-suggestion-indicator="${fieldId}"]`) ??
  root.querySelector<HTMLElement>(`[id="${fieldId}"]`);
